import { ApiError } from '@/api/client/http';

/**
 * True when the API refused the call on AUTHORITY grounds.
 *
 * A 403 is not a failure the operator can retry, so it must never be rendered
 * as a generic error with a "Try again" button. It is a refusal, and it gets
 * a refusal's message: the destination is not permitted for this role.
 *
 * The message names the DESTINATION and never the requirement. "This is not
 * permitted for your role" is safe; "you need `ai.settings.platform.read`" is
 * not — it confirms a code exists and hands out a shopping list.
 */
export function isForbidden(error: Error | null | undefined): boolean {
  return error instanceof ApiError && error.status === 403;
}
